(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.DOMPurify = factory());
}(this, function () { 'use strict';

    var allowedTags = ['p', 'br', 'strong', 'em', 'u', 'i', 'b', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a', 'img'];
    var allowedAttributes = ['href', 'src', 'alt', 'title', 'class', 'id'];

    function sanitize(html) {
        if (typeof html !== 'string') {
            return html;
        }

        // Basic XSS prevention
        html = html.replace(/<script[^>]*>.*?<\/script>/gi, '');
        html = html.replace(/javascript:/gi, '');
        html = html.replace(/on\w+\s*=/gi, '');
        html = html.replace(/<iframe[^>]*>.*?<\/iframe>/gi, '');
        html = html.replace(/<object[^>]*>.*?<\/object>/gi, '');
        html = html.replace(/<embed[^>]*>/gi, '');
        html = html.replace(/<link[^>]*>/gi, '');
        html = html.replace(/<meta[^>]*>/gi, '');

        return html;
    }

    var DOMPurify = {
        sanitize: sanitize,
        isSupported: true
    };

    return DOMPurify;
}));